import(/* webpackMode: "eager", webpackExports: ["TruncatedTextContent"] */ "/app/src/features/truncated-text-content/ui/TruncatedTextContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/shared/ui/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/Container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandsMarqueeSection"] */ "/app/src/widgets/brands-marquee-section/ui/BrandsMarqueeSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogCategorySectionEmpty"] */ "/app/src/widgets/catalog-category-section-empty/ui/CatalogCategorySectionEmpty.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogCategorySection"] */ "/app/src/widgets/catalog-category-section/ui/CatalogCategorySection.tsx");
